
<template>
    <div>
        <v-card class="main-card" v-if="!$AuthSvc.isLogin()">
            <v-card-title style="padding-bottom:0">
                <span class="page-title">Registration</span>
            </v-card-title>
            Must login to register
        </v-card>

        <v-card class="main-card" v-if="$AuthSvc.isLogin()">
            <v-card style="padding: 20px" class="mx-auto mt-5">
                <v-card-title>
                    <h2 style="color:darkgreen;">Tournament Registration</h2>
                </v-card-title>
                <br>

                <v-card style="padding: 10px;margin-bottom: 20px;">
                    <v-card-text>
                        <span class="label14">Course: </span> {{tournament.course.name}} <br/>
                        <span class="label14">Schedule Date: </span> {{printDateTime(tournament.scheduleDate)}} <br/><br/>

                        <span class="label14">Name: </span> {{$AuthSvc.getFullName()}} <br/>
                        <span class="label14">Phone: </span> {{$AuthSvc.getUserInfo().phone}} <br/>
                        <span class="label14">Email: </span> {{$AuthSvc.getUserInfo().email}} <br/>
                        <span class="label14">Flight: </span> {{getFlight($AuthSvc.getUserInfo().flight)}} <br/>
                        <span class="label14">Status: </span> {{$AuthSvc.getUserInfo().status}}<br/><br/>
                    </v-card-text>
                </v-card>

                <v-card-text>
                    <v-form>

                        <v-card-title>Invoice</v-card-title>

                        <span class="label14">Invoice Number: </span> {{invoiceId}}
                        <br><br>

                        <v-card-text class="group-table-card">
                            <v-simple-table class="simple-table">
                                <tr>
                                    <th>Fee Type</th>
                                    <th>Cost</th>
                                </tr>
                                <tr>
                                    <td>Tournament Fee</td>
                                    <td>${{scoreCard.fee + scoreCard.lateFee}}</td>
                                </tr>
                                <tr v-if="isNonMember()">
                                    <td>Membership Fee</td>
                                    <td>${{scoreCard.memberFee}}</td>
                                </tr>
                                <tr>
                                    <td>Hole In One</td>
                                    <td>${{scoreCard.holeInOne}}</td>
                                </tr>
                                <tr v-if="scoreCard.birdieHunt === 'Yes'">
                                    <td>Birdie Hunt</td>
                                    <td>$10</td>
                                </tr>
                                <tr v-for="item in getAllGuests()" :key="item">
                                    <td>{{item.name}}</td>
                                    <td>{{item.cost}}</td>
                                </tr>
                                <tr>
                                    <th>Total Cost</th>
                                    <th>${{scoreCard.owe}}</th>
                                </tr>
                            </v-simple-table>
                        </v-card-text>

                    </v-form>
                </v-card-text>


                <v-divider></v-divider>

                <div id="smart-button-container">
                    <div style="display:none">
                        <input type="text" name="descriptionInput" id="description" maxlength="127" value="">
                    </div>
                    <p id="descriptionError" style="visibility: hidden; color:red; text-align: center;">Please enter a description</p>
                    <div  style="display:none">
                        <input name="amountInput" type="number" id="amount" value=""><span> USD</span>
                    </div>
                    <p id="priceLabelError" style="visibility: hidden; color:red; text-align: center;">Please enter a price</p>
                    <div id="invoiceidDiv" style="display:none">
                        <input name="invoiceid" maxlength="127" type="text" id="invoiceid" value="">
                    </div>
                    <p id="invoiceidError" style="visibility: hidden; color:red; text-align: center;">Please enter an Invoice ID</p>
                    <div style="text-align: center; margin-top: 0.625rem;" id="paypal-button-container"></div>
                </div>

            </v-card>

        </v-card>
    </div>
</template>

<script src="https://www.paypal.com/sdk/js?client-id=sb&enable-funding=venmo&currency=USD" data-sdk-integration-source="button-factory">
</script>

<script>
import moment from 'moment';
import swal from 'sweetalert';

  export default {
    name: "login",
    data: () => ({
      description: '',
      invoiceId: '',
      membershipFee: 0,
      fee: 0,
      totalFee: 0,
      tournament: null,
      userInfo: null,
      scoreCard: null
    }),
   mounted: function() {
        var _this = this;
        _this.userInfo = this.$AuthSvc.getUserInfo();

        var t = window.sessionStorage.getItem('selectTournament');
        if (t === null) {
          _this.$CommandSvc.get(_this, '/public/tournaments/status/REGISTER', function(data) {
              if (data.length === 1) {
                _this.tournament = data[0].tournament;
                t = JSON.stringify(_this.tournament);
                window.sessionStorage.setItem('selectTournament', t);
                _this.getScoreCard(_this.tournament.tournamentId, _this.userInfo.playerId);
              }
          });
        } else {
            _this.tournament = JSON.parse(t);
            _this.getScoreCard(_this.tournament.tournamentId, _this.userInfo.playerId);
        }

        const script = document.createElement("script");
        script.src = "https://www.paypal.com/sdk/js?client-id=AZaF3BdbHjic-erNqcwcQn3_JN9SCirKVdBI7ag_rgajOzLbTzXap22JrnY76ntgkpyBXuCAmiIWJ7Q2&disable-funding=credit&currency=USD";
        script.addEventListener("load", this.setLoaded);
        script.setAttribute("data-sdk-integration-source", "button-factory");
        document.body.appendChild(script);

        window.addEventListener("load", (event) => {
            this.initPayPalButton();
        });
    },
    methods: {
      printDateTime(date) {
        return moment(date).format('MMMM Do hh:mm A');
      },
      printDate(date) {
        return moment(date).format('MMM Do');
      },
      isNonMember() {
        return this.$AuthSvc.getUserInfo().status === 'NON-MEMBER';
      },
      getScoreCard(tournamentId, playerId) {
        var _this = this;
        this.axios.get('/public/scores/players/'+ tournamentId + '/' + playerId)
          .then(function (response) {
            if (response.data !== null && response.data != "") {
                _this.scoreCard = response.data;

                const zeroPad = (num, places) => String(num).padStart(places, '0');
                if (_this.scoreCard !== null) {
                    _this.invoiceId = "1" + zeroPad(_this.scoreCard.scoreCardId, 5);
                }
            }
          })
          .catch(function (error) {
              console.log('ERROR: ' + error);
          });
      },
      getAllGuests() {
         var guests = [];

         if (this.scoreCard.specialRequest !== null && this.scoreCard.specialRequest !== '') {
            var lst = this.scoreCard.specialRequest.split(",");
            for(var j=0; j < lst.length; j++) {
                var items = lst[j].split("-");
                guests.push({name: items[0], cost: items[1]});
            }
         }
         return guests;
      },
      getFlight(flight) {
        if (flight === "Nicklaus") {
            return "Nicklaus (≤0-7.99)";
        } else if (flight === "Palmer") {
            return "Palmer (8-15.99)";
        } else if (flight === "Hogan") {
            "Hogan (16-30+)";
        } else if (flight === "Women") {
            return "Women";
        } else {
            return "Unknown";
        }
      },
      addFee(addFee) {
        this.fee += addFee;
      },
      formSubmit() {
          this.axios.post('/api/scores/registration-complete/'+this.scoreCard.scoreCardId)
          .then(function (response) {
             console.log('DATA: ' + response.data);
             swal({
                  title: "Success!",
                  text: "PayPay paid successfully.",
                  type: "success"
              }).then(function() {
                  window.location.href  = '/schedule';
              });
          })
          .catch(function (error) {
              swal("Error", "PayPay payment failed.", "error");
              console.log('ERROR: ' + error);
          });
      },
      initPayPalButton() {
        var _this = this;

        var description = document.querySelector('#smart-button-container #description');
        var amount = document.querySelector('#smart-button-container #amount');
        var descriptionError = document.querySelector('#smart-button-container #descriptionError');
        var priceError = document.querySelector('#smart-button-container #priceLabelError');
        var invoiceid = document.querySelector('#smart-button-container #invoiceid');
        var invoiceidError = document.querySelector('#smart-button-container #invoiceidError');
        var invoiceidDiv = document.querySelector('#smart-button-container #invoiceidDiv');

        var elArr = [description, amount];

        var purchase_units = [];
        purchase_units[0] = {};
        purchase_units[0].amount = {};

        function validate(event) {
          return event.value.length > 0;
        }

        paypal.Buttons({
          style: {
            color: 'gold',
            shape: 'pill',
            label: 'paypal',
            layout: 'vertical',
          },

          onInit: function (data, actions) {
            actions.enable();
          },

          onClick: function () {

            purchase_units[0].description = _this.description;
            purchase_units[0].amount.value = _this.scoreCard.owe;
            purchase_units[0].invoice_id = _this.invoiceId;
          },

          createOrder: function (data, actions) {
            return actions.order.create({
              purchase_units: purchase_units,
            });
          },

          onApprove: function (data, actions) {
            return actions.order.capture().then(function (orderData) {

              // Full available details
              console.log('Capture result', orderData, JSON.stringify(orderData, null, 2));

              // Show a success message within this page, e.g.
              const element = document.getElementById('paypal-button-container');
              element.innerHTML = '';
              element.innerHTML = '<h3>Thank you for your payment!</h3>';

              _this.formSubmit();

              // Or go to another URL:  actions.redirect('thank_you.html');

            });
          },

          onError: function (err) {
            console.log(err);
          }
        }).render('#paypal-button-container');
      }

    }
  }
</script>

<style scoped>
  .v-card {
    background-color: #e6f2ea;
  }

  .v-checkbox, .v-input {
    margin: 0;
    padding: 0;
  }

  .login {
    margin-top: 12px;
    width: 100%;
  }

  th {
      text-align: left;
      height: 28px;
      background-color: #45472e;
      border:1px solid aquamarine;
      box-shadow:2px 2px 1px -1px #000;
      font-size: 16px;
      color: aquamarine;
      position: sticky;
      position: -webkit-sticky;
      top: 0;
      z-index: 2;
  }

  td {
      font-size: 18px;
      color: #2a2b1e;
      border:1px solid rgba(0,0,0,0.4);
      box-shadow:-1px -1px 1px -1px #000;
  }

  .paypal-input-div label {
    width: 30% !important;
  }

  .paypal-input-div input {
    border: 1px solid black;
    border-radius: 5px;
    padding: 5px;
    width: 67% !important;
  }

  @media (min-width: 768px) {

  }

</style>